import { Hub, Logger, Auth } from 'aws-amplify';
import store from "@/store";
import ebi from '@/ebi';
import graph from '@/graph';

const logger = new Logger('Auth');

const updateLoginState = async () => {
    ebi.main.setLoading();
    
    console.info(await Auth.currentAuthenticatedUser());
    const authObj = await Auth.currentAuthenticatedUser();

    if(authObj)
    {
        console.log("auth::updateLoginState", "authObj", authObj);
        store.state.user = authObj;
        store.state.authState = "signedin";

        const me = await graph.servicecloud.me.get();
        // store.state.me = me;
        store.commit("updateMe", me);
    }

    ebi.main.setLoaded();
};

const listener = async (data: { payload: { event: string}}) => {
    switch (data.payload.event) {
        case 'signIn':
            logger.info('user signed in');
            console.info('user signed in');
            await updateLoginState();
            break;
        case 'signUp':
            logger.info('user signed up');
            console.info('user signed up');
            break;
        case 'signOut':
            logger.info('user signed out');
            console.info('user signed out');
            store.state.user = null;
            store.state.authState = "signedout";
            break;
        case 'signIn_failure':
            logger.error('user sign in failed');
            console.error('user sign in failed');
            break;
        case 'tokenRefresh':
            logger.info('token refresh succeeded');
            console.info('token refresh succeeded');
            break;
        case 'tokenRefresh_failure':
            logger.error('token refresh failed');
            console.error('token refresh failed');
            break;
        case 'configured':
            logger.info('the Auth module is configured');
            console.info('the Auth module is configured');
            await updateLoginState();
    }
}

Hub.listen('auth', listener);